export default __webpack_public_path__ + "static/media/weathericons-regular-webfont.3726e04a.svg";